import {UIGameCanvasController} from '../../../shared/scripts/ui_game/UIGameCanvasController'
import {UIGameResponsiveController} from '../../../shared/scripts/ui_game/UIGameResponsiveController'
import {UIWGameManager} from './UIWGameManager'

export class UIWGameCanvasController extends UIGameCanvasController {
    readonly responsiveController: UIGameResponsiveController
    get chatWidth(): number {
        return this.itemSize * 4
    }
    get popupWidth(): number {
        return this.itemSize * 5
    }
    get bottomViewHeight(): number {
        return this.itemSize
    }

    constructor(uiGameManager: UIWGameManager) {
        super(uiGameManager)
        this.responsiveController = new UIGameResponsiveController(uiGameManager)
    }

    setupGameContainers() {
        super.setCanvasConfigVariables()

        this.kickOffAppLoading()
        this.addTicker()
    }
}
